import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  partner: null,
  rates: [],
  orders: [],
  statistics: null,
  publicPartners: [],
  loading: false,
  error: null
}

export const p2pPartnerSlice = createSlice({
  name: 'p2pPartner',
  initialState,
  reducers: {
    setPartner: (state, action) => {
      state.partner = action.payload
    },
    setRates: (state, action) => {
      state.rates = action.payload
    },
    setOrders: (state, action) => {
      state.orders = action.payload
    },
    setStatistics: (state, action) => {
      state.statistics = action.payload
    },
    setPublicPartners: (state, action) => {
      state.publicPartners = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    addRate: (state, action) => {
      state.rates.push(action.payload)
    },
    updateRate: (state, action) => {
      const index = state.rates.findIndex(rate => rate.id === action.payload.id)
      if (index !== -1) {
        state.rates[index] = action.payload
      }
    },
    removeRate: (state, action) => {
      state.rates = state.rates.filter(rate => rate.id !== action.payload)
    },
    updateOrder: (state, action) => {
      const index = state.orders.findIndex(order => order.id === action.payload.id)
      if (index !== -1) {
        state.orders[index] = action.payload
      }
    }
  },
})

export const { 
  setPartner, 
  setRates, 
  setOrders, 
  setStatistics, 
  setPublicPartners, 
  setLoading, 
  setError,
  addRate,
  updateRate,
  removeRate,
  updateOrder
} = p2pPartnerSlice.actions

export default p2pPartnerSlice.reducer
